const copy = {
  action: {
    formDescription:
      "Please verify that this is the correct phone number to text you.  By clicking 'Submit', you agree to receive a call whenever an agent is available to assist you.",
    notificationRequested: (phoneNumber: string) =>
      `We will call you back at ${phoneNumber} when an agent is available.`,
    requestSubmittedCTA: "Request submitted",
  },
  notificationRequestError:
    "Failed to request a Callback request, please try again",
  // notificationUnreachable: "Your phone number is unreachable. Try again with another phone number."
  notificationUnreachable:
    "We could not reach you at the provided number. Sorry for the inconvenience.",
};

export default copy;
